import { createApi } from '@/api/modules/utils'

const baseUrl = '/article_generation/key_word'
const api = createApi(baseUrl)

// 用户相关API
export const articleWordApi = {
  batchUpload: api('batch_upload', 'post'),
  inputText: api('input_text', 'post'),
  list: api('list', 'get'),
  delete: api('delete', 'get'),
  batchDelete: api('batch_delete', 'get'),
  update: api('update', 'post'),
  search: api('search', 'get'),
  remoteSearch: api('remote_search', 'get'),
  grabKeyword: api('grab_keyword', 'post'),
  grabStatus: api('grab_status', 'get'),
  config: api('config', 'get'),
  grabUrl: api('grab_url', 'post'),
  grabUrlStatus: api('grab_url_status', 'get'),
}
